import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  CfsTemplatePreviewComponent,
  CustomContentTemplateType,
  TemplateAnimationType,
  TemplatePreviewOptions,
  DisabledStateInfo
} from "clearline-common";
import { DigitalAssetScreenSize, TemplateContentType } from "clearline-api";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoModule } from "@ngneat/transloco";

@Component({
  selector: "app-cfs-template-preview-with-header",
  standalone: true,
  imports: [CommonModule, CfsTemplatePreviewComponent, NgbTooltipModule, TranslocoModule],
  templateUrl: "./cfs-template-preview-with-header.component.html",
  styleUrls: ["./cfs-template-preview-with-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CfsTemplatePreviewWithHeaderComponent implements OnInit {
  @Input() screenSize: DigitalAssetScreenSize = DigitalAssetScreenSize.Full;
  @Input() options: TemplatePreviewOptions | null = null;
  @Input() calcAspectRatio = false;
  @Input() disabledInfo: DisabledStateInfo | null = null;

  readonly TemplateAnimationType = TemplateAnimationType;

  title = "";
  previewIcon = "";

  ngOnInit(): void {
    this.title = this.getTitleByOptions(this.options);
    this.previewIcon = this.getIconByCustomContentTemplateType(this.options);
  }

  private getTitleByOptions(options: TemplatePreviewOptions | null): string {
    const { digitalAsset, mediaContent, previewTitle } = options || {};

    return previewTitle || digitalAsset?.title || mediaContent?.title || "";
  }

  private getIconByCustomContentTemplateType(options: TemplatePreviewOptions | null): string {
    const { templateContentType, customContentTemplateType } = options || {};

    if (templateContentType === TemplateContentType.CustomContent) {
      switch (customContentTemplateType) {
        case CustomContentTemplateType.Image:
          return "mdi mdi-image";
        case CustomContentTemplateType.Video:
          return "mdi mdi-video";
        default:
          return "";
      }
    }

    return "";
  }
}
